<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>网站设置</BreadcrumbItem>
          <BreadcrumbItem>联系我们</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">联系我们</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd('serviceStaff')">
          <span class="htb-add">+</span>
          <span>添加</span>
        </div>
      </div>
      <!-- <div class="header-tool-box" v-if="String(showTabs) === '2'">
        <div class="htb-item" @click="showAdd('serviceType')">
          <span class="htb-add">+</span>
          <span>添加类型</span>
        </div>
      </div> -->
    </div>
    <!-- <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="客服人员" name="1">
          <serviceStaff ref="serviceStaff" v-if="String(showTabs) === '1'" />
        </TabPane>
        <TabPane label="客服类型设置" name="2">
          <serviceType ref="serviceType" v-if="String(showTabs) === '2'" />
        </TabPane>
      </Tabs>
    </div> -->
    <serviceStaff ref="serviceStaff" />

  </div>
</template>

<script>
import { mapActions } from "vuex";
import serviceStaff from "./subpages/service-staff.vue";
import serviceType from "./subpages/service-type.vue";

export default {
  name: "project-set",
  data() {
    return {
      showTabs: "1",
    };
  },
  components: {
    serviceStaff,
    serviceType
  },
  created() {
    let query = this.$route.query;
    if (query && query.type && query.type === "staff") {
      this.showTabs = "1";
    }
  },
  methods: {
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=staff`);
      }
    },
    showAdd(name) {
      this.$refs[name].showAdd();
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.eh {
  &-content {
    padding: 24px;
    min-width: 800px;
    .pro {
      height: 400px;
      background-color: #fafafa;
      box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
      margin-bottom: 24px;
      &:hover {
        cursor: pointer;
      }
    }
    .pro-no {
      background-color: #fff;
      .common-bot {
        p {
          color: #333;
        }
      }
    }
    .pro-top {
      width: 100%;
      height: 300px;
      position: relative;
      background-color: #f8f9fb;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        max-height: 100%;
      }
    }
    .pro-bot {
      padding: 12px 24px 24px 24px;
      height: 160px;
    }
    .common-bot {
      position: relative;
      background: #fff;
      p {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
      span {
        position: absolute;
      }
      .type-1 {
        right: 10px;
        bottom: 10px;
      }
      .type-2 {
        right: 20px;
        bottom: 5px;
        color: #ff0000;
      }
    }
    .pro-tool {
      display: flex;
      height: 50px;
      align-items: center;
      justify-content: space-around;
      background-color: #f7f9fa;
      .pro-tool-item {
        flex: 1;
        line-height: 50px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      .pro-tool-line {
        background-color: #e8e8e8;
        font-size: 20px;
        width: 1px;
        height: 22px;
        background-color: #e8e8e8;
      }
    }
  }
}
.plan-p {
  width: 100%;
  height: 50px;
  background-color: #fff;
  line-height: 50px;
  padding: 0 15px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>

